module.exports = __webpack_public_path__ + "static/media/logo-light.1f38fd50.png";